var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.41405 7.99966L12.2421 5.1716L10.8279 3.75739L7.99984 6.58545L5.1718 3.75741L3.75759 5.17163L6.58563 7.99966L3.75684 10.8285L5.17105 12.2427L7.99984 9.41388L10.8287 12.2427L12.2429 10.8285L9.41405 7.99966Z",
    fill: "#0088CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideCancel);
export default __webpack_public_path__ + "static/media/side-cancel.0f6756e64c65b7ad26b177a6c1ca00b8.svg";
export { ForwardRef as ReactComponent };